// tanstack
import { createFileRoute } from '@tanstack/react-router';

// feature-components
import EnergyTreeNodeAnalysisPage from '@/features/energyxplorer/components/analysis/EnergyTreeNodeAnalysisPage';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/energy-analysis',
)({
  component: EnergyTreeNodeAnalysisPage,
});
